<!--厦大酒精检测功能-->
<template>
    <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
        <!-- 页面标题 -->
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs-container">
            <!--检测记录-->
            <el-tab-pane label="检测记录" name="record">
                <div class="page_header">

                    <el-form :inline="true" :size="size" style="flex:1;text-align: right;">

                        <el-form-item :label="$t('time.timeQuery')">
                            <el-date-picker v-model="recordSearch.date" type="date" value-format="yyyy-MM-dd"
                                :placeholder="$t('龙翼简报.选择日期')">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="searchRecord">{{ $t('public.query')
                            }}</el-button>
                            <!-- <el-button type="success" icon="el-icon-download" @click="exportDaily">导出</el-button> -->
                        </el-form-item>

                    </el-form>
                </div>
                <el-divider></el-divider>
                <div class="page_container" style="padding-bottom: 20px;">
                    <el-table :data="recordData"  :height="height" border stripe style="width: 100%" v-loading="loading">
                        <el-table-column type="index" label="序号" width="50" align="center">
                        </el-table-column>
                        <el-table-column prop="ICNumber" label="工号" width="120" align="center"></el-table-column>
                        <el-table-column prop="AlcoholValue" label="浓度值(mg/ml)" align="center">
                            <template slot-scope="scope">
                                <!--大于0.5为异常-->

                                <span v-if="scope.row.AlcoholStatus != '0'" class="status-abnormal">{{
                                    scope.row.AlcoholValue }}</span>
                                <span v-else> {{ scope.row.AlcoholValue }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="TestDateTime" label="检测时间" align="center"></el-table-column>
                        <el-table-column prop="AlcoholStatus" label="检测结果" align="center">
                            <template slot-scope="scope">
                                <!--大于0.5为异常-->

                                <span v-if="scope.row.AlcoholStatus != '0'" class="status-abnormal">异常</span>
                                <span v-else class="status-normal">正常</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Picture" label="图片" align="center">
                            <template slot-scope="scope">
                                <el-image style="width: 100px; height: 100px" :src="scope.row.Picture"
                                    :preview-src-list="[scope.row.Picture]">
                                </el-image>

                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </el-tab-pane>
            <!-- 日报表标签 -->
            <el-tab-pane label="日报表" name="daily">
                <div class="page_header">

                    <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
                        <el-form-item label="姓名:">
                            <el-input v-model="dailySearch.name" clearable placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="工号:">
                            <el-input v-model="dailySearch.empId" clearable placeholder="请输入工号"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('time.timeQuery')">
                            <el-date-picker v-model="dailySearch.date" type="date" value-format="yyyy-MM-dd"
                                :placeholder="$t('龙翼简报.选择日期')">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="searchDaily">{{ $t('public.query')
                            }}</el-button>
                            <el-button type="success" icon="el-icon-download" @click="exportDaily">导出</el-button>
                        </el-form-item>

                    </el-form>
                </div>
                <el-divider></el-divider>
                <div class="page_container" style="padding-bottom: 20px;">
                    <el-table :data="dailyData" border  :height="height" stripe style="width: 100%" v-loading="loading">
                        <el-table-column prop="index" label="序号" width="80" align="center"></el-table-column>
                        <el-table-column prop="employee_sn" label="工号" width="120" align="center"></el-table-column>
                        <el-table-column prop="employee_name" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="job_position_name" label="岗位" align="center"></el-table-column>
                        <el-table-column prop="department_name" label="区域" align="center"></el-table-column>
                        <el-table-column prop="testDateTime" label="检测时间" align="center"></el-table-column>
                        <el-table-column prop="alcoholStatus" label="检测结果" align="center">
                            <template slot-scope="scope">
                                <span
                                    :class="scope.row.alcoholStatus === '正常' ? 'status-normal' : scope.row.alcoholStatus === '未打卡' ? 'status-warning' : 'status-abnormal'">
                                    {{ scope.row.alcoholStatus }}
                                </span>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="月报表" name="monthly">
                <div class="page_header">

                    <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
                        <el-form-item label="姓名:">
                            <el-input v-model="monthlySearch.name" clearable placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="工号:">
                            <el-input v-model="monthlySearch.empId" clearable placeholder="请输入工号"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('time.timeQuery')">
                            <el-date-picker v-model="monthlySearch.month" type="month" value-format="yyyy-MM"
                                :placeholder="$t('龙翼简报.选择月份')">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="searchMonthly">{{ $t('public.query')
                            }}</el-button>
                            <el-button type="success" icon="el-icon-download" @click="exportMonthly">导出</el-button>
                        </el-form-item>

                    </el-form>
                </div>
                <el-divider></el-divider>
                <div class="page_container" style="padding-bottom: 20px;">
                    <div class="horizontal-scroll">
                        <el-table :data="monthlyData" border  :height="height" stripe style="width: 100%" v-loading="loading">
                            <el-table-column prop="index" label="序号" width="80" align="center"></el-table-column>
                            <el-table-column prop="employee_sn" label="工号" width="120" align="center"></el-table-column>
                            <el-table-column prop="employee_name" label="姓名" width="120"
                                align="center"></el-table-column>
                            <el-table-column v-for="day in daysInMonth" :key="day" :prop="`day${day}`"
                                :label="`${day}号`" width="100" align="center">
                                <template slot-scope="scope">
                                    <span :class="scope.row[`day${day}`] === '正常' ? 'status-normal' :
                                        scope.row[`day${day}`] === '未打卡' ? 'status-warning' :
                                            scope.row[`day${day}`] === '异常' ? 'status-abnormal' : ''">
                                        {{ scope.row[`day${day}`] || '-' }}
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                </div>
            </el-tab-pane>
        </el-tabs>



    </div>
</template>
<script>
import { queryVehicleAlcoholData, queryAlcoholTestDataDetail } from '@/http/vehicle'

export default {
    name: 'AlcoholTestData',
    data() {
        // 获取当前日期
        const today = new Date();
        const currentDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
        const currentMonth = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}`;

        return {
            activeTab: 'record',
            loading: false,
            recordSearch: {
                name: '',
                empId: '',
                date: currentDate
            },

            dailySearch: {
                name: '',
                empId: '',
                date: currentDate
            },
            monthlySearch: {
                name: '',
                empId: '',
                month: currentMonth
            },
            recordData: [],

            dailyData: [],
            monthlyData: [],
            // 当月天数
            daysInMonth: []
        }
    },
    computed: {
        size() {
            return this.$store.getters.size
        },
        height() {
            return window.innerHeight - 300
        },

    },
    mounted() {
        // 初始化数据
        this.generateRecordData();
        this.generateDailyData();
        this.updateDaysInMonth();
        this.generateMonthlyData();
    },
    methods: {
        generateRecordData(isExport) {
            isExport = isExport || 0;

            this.loading = true;
            queryAlcoholTestDataDetail(
                {
                    TestDateTime: this.recordSearch.date,
                    PageNo: 1,
                    PageSize: 1000,



                }, isExport == 1 ? 'blob' : 'json'
            ).then(res => {
                this.loading = false;


                this.recordData = res.data || [];


            })


        },
        // 生成模拟月报表数据（增加数据量）
        generateMonthlyData(isExport) {
            isExport = isExport || 0;
            this.updateDaysInMonth();

            this.loading = true;
            queryVehicleAlcoholData(
                {
                    type: 1,
                    date: this.monthlySearch.month,
                    employeeID: this.monthlySearch.empId,
                    employeeName: this.monthlySearch.name,
                    isExport: isExport,
                    fileName: `酒精测试月数据_${this.monthlySearch.month}`

                }, isExport == 1 ? 'blob' : 'json'
            ).then(res => {
                this.loading = false;

                if (isExport == 1) {
                    let blob = new Blob([res], {
                        type: "application/vnd.ms-excel;charset=utf-8",
                    }); // 重点代码

                    let a = document.createElement("a");
                    a.href = window.URL.createObjectURL(blob);
                    a.download = `酒精测试月数据_${this.monthlySearch.month}` + '.xlsx'; // 默认文件名

                    a.click(); // 执行下载
                    window.URL.revokeObjectURL(blob); // 释放ur
                    // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
                } else {
                    if (res.code === 200) {
                        this.monthlyData = res.data || [];
                    }
                }
            })


        },
        // 生成模拟日报表数据（增加数据量）
        generateDailyData(isExport) {
            isExport = isExport || 0;
            this.loading = true;
            queryVehicleAlcoholData(
                {
                    type: 0,
                    date: this.dailySearch.date,
                    employeeID: this.dailySearch.empId,
                    employeeName: this.dailySearch.name,
                    isExport: isExport,
                    fileName: `酒精测试日数据_${this.dailySearch.date}`
                }, isExport == 1 ? 'blob' : 'json'
            ).then(res => {
                this.loading = false;

                if (isExport == 1) {
                    let blob = new Blob([res], {
                        type: "application/vnd.ms-excel;charset=utf-8",
                    }); // 重点代码

                    let a = document.createElement("a");
                    a.href = window.URL.createObjectURL(blob);
                    a.download = `酒精测试日数据_${this.dailySearch.date}` + '.xlsx'; // 默认文件名

                    a.click(); // 执行下载
                    window.URL.revokeObjectURL(blob); // 释放ur
                    // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
                } else {
                    if (res.code === 200) {
                        this.dailyData = res.data || [];
                    }
                }
            })

        },
        // 导出日报表
        exportDaily() {
            this.generateDailyData(1);
        },
        // 查询日报表
        searchDaily() {
            this.generateDailyData();
        },
        searchRecord() {
            this.generateRecordData();
        },
        // 导出月报表
        exportMonthly() {
            this.generateMonthlyData(1);
        },
        // 查询月报表
        searchMonthly() {
            this.generateMonthlyData();
        },
        handleTabClick(tab) {
            if (tab.name === 'monthly') {
                this.updateDaysInMonth();
            }
        },
        // 更新当月天数
        updateDaysInMonth() {
            if (!this.monthlySearch.month) return;
            const [year, month] = this.monthlySearch.month.split('-').map(Number);
            const days = new Date(year, month, 0).getDate();

            this.daysInMonth = Array.from({ length: days }, (_, i) => i + 1);
        },
    }
}
</script>
<style scoped>
.status-normal {
    color: #000;
}

.status-abnormal {
    color: #f5222d;
}

.status-warning {
    color: #faad14;
}
</style>